import React from 'react';
import { useNavigate } from 'react-router-dom';

import file04 from '@/assets/files/대한화장품학회_심사규정및연구윤리.pdf';
import file02 from '@/assets/files/대한화장품학회_자체평가서.pdf';
import file03 from '@/assets/files/대한화장품학회_투고규정.pdf';
import useIsMobile from '@/hooks/useIsMobile';
import { useModalStore } from '@/store/modalStore';
import { useTokenStore } from '@/store/tokenStore';
import { downloadFileFromFrontend } from '@/utils/fileUtils.ts';

import * as S from './style.ts';

const PublicationSubmissionGuide: React.FC = () => {
	const isMobile = useIsMobile(900);

	const navigate = useNavigate();
	const { isLogin } = useTokenStore();
	const { showModal } = useModalStore();

	const onClickBtn = (sort: string) => {
		switch (sort) {
			case '01':
				window.open('https://scsk.jams.or.kr/co/main/jmMain.kci', '_blank', 'noopener,noreferrer');
				break;

			case '02':
				downloadFileFromFrontend(file02, '대한화장품학회_자체평가서.pdf');
				break;

			case '03':
				downloadFileFromFrontend(file03, '대한화장품학회_투고규정.pdf');
				break;

			case '04':
				downloadFileFromFrontend(file04, '대한화장품학회_심사규정및연구윤리.pdf');
				break;
		}
	};

	return (
		<S.Container>
			<S.ContentBox>
				<S.ContentTitle>
					투고안내
					<a href="https://scsk.jams.or.kr/co/main/jmMain.kci" target="_blank" rel="noopener noreferrer">
						학회논문투고시스템(JMAS) 바로가기
					</a>
				</S.ContentTitle>
				<S.ContentItems>
					<S.ContentListLayout>
						<S.ContentTitleSub>01</S.ContentTitleSub>
						<S.ContentDescription>논문투고는 홈페이지에서 온라인상으로만 가능합니다.</S.ContentDescription>
					</S.ContentListLayout>
					<S.ContentListLayout>
						<S.ContentTitleSub>02</S.ContentTitleSub>
						<S.ContentDescription>논문 투고는 본회의 회원이어야 가능합니다.(단, 초청 투고자는 예외)</S.ContentDescription>
					</S.ContentListLayout>
					<S.ContentListLayout>
						<S.ContentTitleSub>03</S.ContentTitleSub>
						<S.ContentDescription>
							주저자의 경우 본 학회 회원이어야 하며, 회원이 아닌 경우에는 <strong>회원가입을 하시고 회비를 납부</strong>하여 주시기 바랍니다.
						</S.ContentDescription>
					</S.ContentListLayout>
					<S.ContentListLayout>
						<S.ContentTitleSub>04</S.ContentTitleSub>
						<S.ContentDescription>논문투고 시 아래의 첨부된 자체평가서를 체크하시어 같이 투고하시기 바랍니다.</S.ContentDescription>
					</S.ContentListLayout>
					<S.ContentListLayout>
						<S.ContentTitleSub>05</S.ContentTitleSub>
						<S.ContentDescription>투고에 관한 자세한 사항은 투고규정을 확인하시기 바랍니다.</S.ContentDescription>
					</S.ContentListLayout>
					<S.ContentListLayout>
						<S.ContentTitleSub>06</S.ContentTitleSub>
						<S.ContentDescription>
							본 학회 대한화장품학회지에 논문을 투고하시기 위해, 본 홈페이지에서 회원가입 및 연회비 납부 후 JAMS(논문투고관리시스템) 대한화장품학회에 추가
							회원가입이 필요합니다. 또는 학회 사무국 scsk1968@naver.com으로 논문 제출 부탁드립니다. 논문투고시스템과 본 학회 홈페이지가 연동되지 않은 관계로
							불편을 드려 죄송합니다.
						</S.ContentDescription>
					</S.ContentListLayout>
				</S.ContentItems>
			</S.ContentBox>

			<S.ContentBox>
				<S.ContentTitle>원고접수</S.ContentTitle>
				<S.Table className="table1">
					<S.TableHeadCell className="item1 center">권/호</S.TableHeadCell>
					<S.TableHeadCell className="center">발간예정일</S.TableHeadCell>

					<S.TableCell className="min-height point item2 center">매년</S.TableCell>

					<S.TableCell className="min-height point center">1호</S.TableCell>
					<S.TableCell className="min-height center">03월 30일</S.TableCell>

					<S.TableCell className="min-height point center">2호</S.TableCell>
					<S.TableCell className="min-height center">06월 30일</S.TableCell>

					<S.TableCell className="min-height point center">3호</S.TableCell>
					<S.TableCell className="min-height center">09월 30일</S.TableCell>

					<S.TableCell className="min-height point center">4호</S.TableCell>
					<S.TableCell className="min-height center">12월 30일</S.TableCell>
				</S.Table>
				<S.ContentDescription>원고접수는 학회JAMS사이트를 통해 수시로 접수하고 있습니다.</S.ContentDescription>
			</S.ContentBox>

			<S.ContentBox>
				<S.ContentTitle>논문투고절차</S.ContentTitle>
				<S.Table className="table2">
					<S.TableHeadCell style={{ gridArea: 'item1' }} className="center">
						01
					</S.TableHeadCell>
					<S.TableHeadCell style={{ gridArea: 'item2' }} className="center">
						02
					</S.TableHeadCell>
					<S.TableHeadCell style={{ gridArea: 'item3' }} className="center">
						03
					</S.TableHeadCell>
					<S.TableHeadCell style={{ gridArea: 'item4' }} className="center">
						04
					</S.TableHeadCell>

					<S.TableCell style={{ gridArea: 'item5' }} className="min-height point center">
						<S.TableCellLayout>
							<p>회원가입{isMobile ? ' ' : <br />}(사)대한화장품학회</p>
							<S.Button onClick={() => onClickBtn('01')}>회원가입</S.Button>
						</S.TableCellLayout>
					</S.TableCell>
					<S.TableCell style={{ gridArea: 'item6' }} className="min-height point center">
						<S.TableCellLayout>
							<p>자체평가서{isMobile ? ' ' : <br />}다운로드</p>
							<S.Button onClick={() => onClickBtn('02')}>자체평가서 다운로드</S.Button>
						</S.TableCellLayout>
					</S.TableCell>
					<S.TableCell style={{ gridArea: 'item7' }} className="min-height point center">
						<S.TableCellLayout>
							<p>논문작성 (한글 hwp){isMobile ? ' ' : <br />}/ 논문투고</p>
							<S.Button onClick={() => onClickBtn('03')}>투고규정</S.Button>
						</S.TableCellLayout>
					</S.TableCell>
					<S.TableCell style={{ gridArea: 'item8' }} className="min-height point center">
						<S.TableCellLayout>
							<p>논문심사{isMobile ? ' ' : <br />}/ 게재확정</p>
							<S.Button onClick={() => onClickBtn('04')}>심사규정 및 연구윤리</S.Button>
						</S.TableCellLayout>
					</S.TableCell>
				</S.Table>
			</S.ContentBox>
		</S.Container>
	);
};

export default PublicationSubmissionGuide;
